module.exports = __webpack_public_path__ + "static/media/grey-arrow-down.2ada8f47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/grey-arrow-down.svg
// module id = 851
// module chunks = 21